import { RequestProvider } from '@/shared/providers/request.provider';
import { ErrorProvider } from '@/shared/providers/errors.provider';
import { MEETINGS_API, API_VARIABLES, MEETING_TYPES_VALUES } from '../values/meetings.values';
import { RequestMeeting } from '../models/request-meeting.model';
import { RequestSet } from '../models/request-set.model';
import { AuthStore } from '@/auth/store/auth.store';
import MeetingUserConnectedResponse from '@/meetings/models/meeting-user-connected-response.model';
import MeetingInformationResponse from '../models/meeting-information-response.model';
import BoardAnnotations from '@/homework/models/board-annotations.model';

class MeetingsServiceClass {

  /* GET */

  getSetsFromClass(classId:number){
    return new Promise((resolve, reject) => {
      let req = MEETINGS_API.GET_MEETINGS_FROM_CLASS.replace(API_VARIABLES.CLASS_ID,classId.toString());
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  getMeetingStudentsList(meetingId:number){
    return new Promise((resolve, reject) => {
      let req = MEETINGS_API.GET_MEETING_STUDENTS_LIST.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }
  
  async getSpecificMeetingService(meetingId:number, service:MEETING_TYPES_VALUES){
    let req = MEETINGS_API.GET_SPECIFIC_SERVICE.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
    req = req.replace(API_VARIABLES.SERVICE,service);
    return RequestProvider.get(req)
  }

  getAllMeetingServices(meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.GET_ALL_SERVICES.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  getMeetingAtendees(meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.GET_MEETING_ATENDEES.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  getAllUserMeetingsPublisher(){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.GET_ALL_USER_MEETINGS_PUBLISHER;
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  getAllUserMeetingsViewer(){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.GET_ALL_USER_MEETINGS_VIEWER;
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  getMeetingInfo(meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.GET_MEETING_INFO.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      RequestProvider.get(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  async getUserClassRooms(): Promise<any> {
    return RequestProvider.get(MEETINGS_API.GET_USER_CLASS_ROOMS);
  }


  /* POST */

  createSet(set:RequestSet){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.CREATE_SET;
      RequestProvider.post(req, set).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  createOrUpdateGroup(group:RequestMeeting){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.CREATE_OR_UPDATE_MEETING;
      RequestProvider.post(req, group).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  obtainBoardAnnotations(boardGroupHash: string) : Promise<BoardAnnotations> {
    try {
      return RequestProvider.get(MEETINGS_API.OBTAIN_TRANSPARENCY_BOARD_ANNOTATIONS.replace('{boardGroup}', boardGroupHash));
    } catch(error) {
      throw ErrorProvider.getError(error.error);
    }
  }


  /* PUT */

  updateSet(set:RequestSet,meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.UPDATE_SET.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      RequestProvider.put(req, set).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  updateSpecificMeetingService(meetingId:number, service:MEETING_TYPES_VALUES){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.GET_SPECIFIC_SERVICE.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      req = req.replace(API_VARIABLES.SERVICE,service);
      RequestProvider.post(req).then(res => {
        resolve(res);
      }).catch(err => {
        reject(err);
      });
    });
  }

  addStudentToGroup(studentId:number, meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.ADD_OR_REMOVE_STUDENT_FROM_MEETING.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      req = req.replace(API_VARIABLES.STUDENT_ID,studentId.toString());
      RequestProvider.put(req).then(res => {
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    })
  }

  /* DELETE */

  deleteStudentInGroup(studentId:number, meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.ADD_OR_REMOVE_STUDENT_FROM_MEETING.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      req = req.replace(API_VARIABLES.STUDENT_ID,studentId.toString());
      RequestProvider.remove(req).then(res => {
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    })
  }

  deleteGroupOrSet(meetingId:number){
    return new Promise((resolve,reject) => {
      let req = MEETINGS_API.DELETE_MEETING_OR_SET.replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      RequestProvider.remove(req).then(res => {
        resolve(res);
      }).catch(error => {
        reject(error)
      });
    });
  }

  async getPresentationModeMeetingInformation(meetingId:number) : Promise<MeetingInformationResponse> {
    try {
      let req = `${MEETINGS_API.PRESENTATION_MODE_MEETING_INFORMATION}`.replace(API_VARIABLES.MEETING_ID, meetingId.toString());
      return await RequestProvider.requestRealtime('GET', req)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async validatePresentationModeSession(meetingId : number, user : string) : Promise<MeetingUserConnectedResponse> {
    try {
      let req = `${MEETINGS_API.VALIDATE_PRESENTATION_MODE_SESSION}`
        .replace(API_VARIABLES.MEETING_ID, meetingId.toString())
        .replace(API_VARIABLES.USER, user);
      return await RequestProvider.requestRealtime('GET', req)
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async setPresentationModeHomeworkText(classId: number, sectionId: number, text: string): Promise<void> {
    try {
      const req: string = MEETINGS_API.SET_PRESENTATION_MODE_HOMEWORK_TEXT;
      return await RequestProvider.requestRealtime('POST', req, { classId, sectionId, text });
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async getPresentationModeHomeworkText(classId: number, sectionId: number): Promise<any> {
    try {
      const req: string = MEETINGS_API.GET_PRESENTATION_MODE_HOMEWORK_TEXT
        .replace(API_VARIABLES.CLASS_ID, String(classId))
        .replace(API_VARIABLES.SECTION_ID, String(sectionId));
      return await RequestProvider.requestRealtime('GET', req);
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async deletePresentationModeHomeworkText(classId: number, sectionId: number): Promise<void> {
    try {
      const req: string = MEETINGS_API.DELETE_PRESENTATION_MODE_HOMEWORK_TEXT
        .replace(API_VARIABLES.CLASS_ID, String(classId))
        .replace(API_VARIABLES.SECTION_ID, String(sectionId));
      return await RequestProvider.requestRealtime('DELETE', req);
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }

  async getPresentationModeStatus(meetingId:number): Promise<any> {
    try {
      const req: string = MEETINGS_API.GET_PRESENTATION_MODE_STATUS
        .replace(API_VARIABLES.MEETING_ID,meetingId.toString());
      return await RequestProvider.requestRealtime('GET', req);
    } catch (error) {
      throw ErrorProvider.getError(error.error);
    }
  }
}

export const MeetingsService = new MeetingsServiceClass();